import Queue from 'async-await-queue'
import amapi from '@/api/amapi'

// Let’s Encrypt certificates

const initialState = () => ({
  certificates: [],
  runningQueue: false,
})

const state = initialState()

const getters = {
  certificates: state => state.certificates,
  runningQueue: state => state.runningQueue,
}

const mutations = {
  SET_CERTIFICATES (state, certificates) {
    state.certificates = certificates
  },
  ADD_CERTIFICATES (state, certificates) {
    const autoSsl = certificates.filter(cert => cert.certificate?.is_autossl)
    if (!autoSsl.length) {
      return
    }
    state.certificates.push(...autoSsl)
  },
  SET_RUNNING_QUEUE (state, running) {
    state.runningQueue = running
  },
}

const actions = {
  /**
   * @param serviceIds { Array }
   */
  async runSharedCertificatesQueue ({ commit, dispatch, getters }, serviceIds) {
    const queue = new Queue(1, 100)
    commit('SET_RUNNING_QUEUE', true)
    for (const id of serviceIds) {
      // eslint-disable-next-line symbol-description
      const task = Symbol()
      await queue.wait(task, -1)
      dispatch('getSharedCertificates', id)
        .catch(e => console.warn(e))
        .finally(() => queue.end(task))
    }
    commit('SET_RUNNING_QUEUE', false)
    return queue.flush()
  },
  async getSharedCertificates ({ commit, dispatch }, id) {
    const data = {
      id,
      params: {
        uapi_module: 'SSL',
        uapi_function: 'installed_hosts'
      }
    }
    const response = await amapi.makecall('cpanel_uapi', data)
    // add certificates to the list
    const certificates = Array.isArray(response.payload.data) ? response.payload.data.map(crt => ({
      serviceId: id,
      ...crt,
    })) : []
    commit('ADD_CERTIFICATES', certificates)
    return Promise.resolve()
  },
  async runResellerCertificatesQueue ({ commit, dispatch }, serviceIds) {
    commit('SET_RUNNING_QUEUE', true)
    const cpQueue = new Queue(1, 100)
    // get cpanel users list for each account
    const cpanelUsers = []
    for (const sid of serviceIds) {
      // eslint-disable-next-line symbol-description
      const cpTask = Symbol()
      await cpQueue.wait(cpTask, -1)
      const response = await amapi.makecall('ssl_list_cpanels', { hosting_id: sid })
      if (Array.isArray(response.cpanels)) {
        response.cpanels.forEach(username => {
          cpanelUsers.push({
            id: sid,
            username
          })
        })
      }
      cpQueue.end(cpTask)
    }
    await cpQueue.flush()
    // get certificates list for each cpanel account through whm uapi
    const certQueue = new Queue(1, 100)
    for (const cpUser of cpanelUsers) {
      // eslint-disable-next-line symbol-description
      const task = Symbol()
      await certQueue.wait(task, -1)
      try {
        await dispatch('getResellerCertificates', cpUser)
      } catch (e) {
        console.warn(e)
      } finally {
        certQueue.end(task)
      }
    }
    await certQueue.flush()
    commit('SET_RUNNING_QUEUE', false)
  },
  async getResellerCertificates ({ commit, dispatch }, { id, username }) {
    const data = {
      id,
      username,
      module: 'SSL',
      method: 'installed_hosts'
    }
    const response = await amapi.whm_uapi(data)
    if (Array.isArray(response.data.result.data)) {
      const certificates = response.data.result.data.map(crt => ({
        serviceId: id,
        cpUsername: username,
        isReseller: true,
        ...crt,
      }))
      commit('ADD_CERTIFICATES', certificates)
    }
    return Promise.resolve()
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
}
